import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ProviderGroupDTO} from '../models/ProviderGroupDTO';
import {PriceListDTO, ProviderPriceListLinkDTO} from '../models/PriceListDTO';
import {AtcDTO} from '../../pbm/models/AtcDTO';
import {PriceListUploadDTO} from '../models/PriceListUploadDTO';

@Injectable({
  providedIn: 'root'
})
export class PriceListService {
  private url = environment.baseUrl + '/provider-price-list';

  constructor(private httpClient: HttpClient) {
  }

  getListOfPriceLists(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<any>> {
    return this.httpClient.post<PagedResponseDTO<any>>(this.url + '/filter', pagedRequestDTO);
  }

  deletePriceList(id: number) {
    return this.httpClient.delete<{}>(this.url + '/' + id);
  }

  getPriceList(providerPriceListId: number): Observable<PriceListDTO> {
    return this.httpClient.get<PriceListDTO>(this.url + '/' + providerPriceListId);
  }

  savePriceList(priceListDTO: PriceListDTO): Observable<PriceListDTO> {
    return this.httpClient.post<PriceListDTO>(this.url, priceListDTO);
  }

  convertPriceListUploadDTO(priceListUploadArray: PriceListUploadDTO[]): Observable<ProviderPriceListLinkDTO[]> {
    return this.httpClient.post<ProviderPriceListLinkDTO[]>(this.url + '/convert-to-link-dto', priceListUploadArray);
  }

  convertPriceListLinkDTO(priceListLinkArray: ProviderPriceListLinkDTO[]): Observable<PriceListUploadDTO[]> {
    return this.httpClient.post<PriceListUploadDTO[]>(this.url + '/convert-to-upload-dto', priceListLinkArray);
  }

}
